import React from "react";
import { useSelector } from "react-redux";
import { getText, isRTL } from "../i18n";

const Loader = () => {
  const currentLang = useSelector((state) => state.language.currentLanguage);
  const t = getText(currentLang, "common");

  return (
    <div className={`facturize-loader-wrapper ${isRTL(currentLang) ? "rtl-mode" : ""}`}>
      <div className="facturize-loader-content position-relative">
        <div className="facturize-loader-mark" aria-hidden="true">
          <div className="facturize-spinner">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
          </div>
          <div className="facturize-loader-logo">F</div>
        </div>

        <div className="loader-text-container">
          <h2 className="main-text">
            {t.loading} <span className="brand-highlight">FACTURIZE</span>
          </h2>
          <div className="sub-text">{t.wait}</div>
        </div>
      </div>

      <div className="facturize-copyright-loader">
        © {new Date().getFullYear()} FACTURIZE - {t.system}
      </div>
    </div>
  );
};

export default Loader;
